import { Fragment } from 'react'

import getPaginationInfo from './getPaginationInfo'

const Pagination = (props) => {
  const {
    pageNumbers,
    current,
    firstPage,
    lastPage,
    next,
    prev
  } = getPaginationInfo(props)
  const { setPage } = props

  return (
    <nav className="new-pagination">
      { current !== 1 &&
        <Fragment>
          <button
            className="pagination-button first"
            onClick={() => setPage(firstPage)}
          >
            <i className="glyph glyph-double-arrow-left" />
          </button>

          <button
            className="pagination-button first"
            onClick={() => setPage(prev)}
            rel="prev"
          >
            <i className="glyph glyph-arrow-left" />
          </button>
        </Fragment>
      }

      {
        pageNumbers.map(({ number }) => {
          if (number === current) {
            return <span key={number} className="pagination-button current">{number}</span>
          }

          return (
            <button
              className="pagination-button"
              key={number}
              onClick={() => setPage(number)}
            >
              {number}
            </button>
          )
        })
      }

      {
        current !== lastPage &&
        <Fragment>
          <button
            className="pagination-button last"
            onClick={() => setPage(next)}
            rel="next"
          >
            <i className="glyph glyph-arrow-right" />
          </button>

          <button
            className="pagination-button last"
            onClick={() => setPage(lastPage)}
          >
            <i className="glyph glyph-double-arrow-right" />
          </button>
        </Fragment>
      }
    </nav>
  )
}

export default Pagination
